import { useEffect, useRef, useState } from 'react';
import images from '../../assets/images';
import './ExamGuideContainer.scss';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import MaterialActionsOverlay from '../ActionsOverlay/MaterialActionsOverlay';
import { getMenuItems } from '../../utils/helper';
import { useAppSelector } from '../../redux/app/hooks';
import { STUDENT_ROLE } from '../../utils/constants';
import { Tooltip } from '@mui/material';
interface guidesData {
   filename: string;
   filepath: string;
   filesize: number;
   isclassroom: boolean;
   coverimagepath: string;
   authorname: string;
   fileId: string;
}
interface ExamGuideContainerProps {
   handleOpenFile: (guidesData: guidesData) => void;
   guidesData: [guidesData] | undefined;
   handleMaterialActions: (data:guidesData,action:string) => void;
}

const ExamGuideContainer: React.FC<ExamGuideContainerProps> = ({ handleOpenFile, guidesData, handleMaterialActions }) => {
   const { greyMoreIcon, guideDefaultImage, ShareIcon, ShareGif, RightClickArrow, DeleteGif } = images;
   const baseUrl = process.env.REACT_APP_FRONTEND_URL;
   const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
   const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
   const [openOverlay, setOpenOverlay] = useState<boolean>(false);
   const [selectedMaterial, setSelectedMaterial] = useState<guidesData | null>(null);
   const [action, setAction] = useState<string>('');
   const role = useAppSelector((state) => state.auth.role);
   const guideTitleRef = useRef<HTMLDivElement | null>(null);
   const [isOverflow, setIsOverflow] = useState(false);


     //To check the container is overflow
  

   // click yes button in confirmation popup
   const onYesButtonClick = () => {
      setOpenConfirmationPopup(false);
      if (selectedMaterial)
         handleMaterialActions(selectedMaterial, action)
   }

   // click no button in confirmation popup
   const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
   }

   const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, guideData: guidesData | undefined) => {
      event.stopPropagation(); // Stop propagation to prevent triggering parent click
      if (guideData) {
         setSelectedMaterial(guideData);
         if (guideData?.isclassroom === true) {
            setAnchorEl(event.currentTarget);
            setOpenOverlay(true);
         } else if (guideData?.isclassroom === false) {
            setAction('share');
            setOpenConfirmationPopup(true);
         }
      }
   };

   const handleCloseActions = () => {
      setAnchorEl(null);
      setOpenOverlay(false);
   };

   const menuItems = handleMaterialActions ? getMenuItems(handleCloseActions, handleMaterialActions, setOpenConfirmationPopup, setAction, selectedMaterial):[];

    


       const filenameRefs = useRef<(HTMLParagraphElement | null)[]>([]);
  const authorRefs = useRef<(HTMLParagraphElement | null)[]>([]);
  const [overflowStates, setOverflowStates] = useState<{ [key: number]: { filename: boolean; author: boolean } }>({});

  const checkOverflow = (index: number, type: "filename" | "author") => {
    const el = type === "filename" ? filenameRefs.current[index] : authorRefs.current[index];

    if (el) {
      setOverflowStates((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [type]: el.scrollWidth > el.clientWidth,
        },
      }));
    }
  };

       
   return (
      <div className={`${guidesData && guidesData?.length > 0 ? role === STUDENT_ROLE ? 'examGuideContainerStudent' : 'examGuideContainer' : 'noData'}`}>
         {guidesData && guidesData.length > 0 ? (
            guidesData.map((guide: guidesData, index) => (
               <div className={role === STUDENT_ROLE ? "student-exam-guide":"exam-guide"} key={guide.filepath} onClick={() => handleOpenFile(guide)}>
                  <div className='guideContentCtn'>
                     <img src={guide?.coverimagepath ? baseUrl + guide?.coverimagepath : guideDefaultImage} alt="guide-profile" className='guideProfile' />
                     <div className='guideNameCtn'>
                     <Tooltip title={guide?.filename} disableHoverListener={!overflowStates[index]?.filename}>
            <p
              ref={(el) => (filenameRefs.current[index] = el)}
              className="guideTitle"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              onMouseEnter={() => checkOverflow(index, "filename")}
            >
              {guide?.filename}
            </p>
          </Tooltip>

          {/* Author Tooltip */}
          <Tooltip title={guide?.authorname} disableHoverListener={!overflowStates[index]?.author}>
            <p
              ref={(el) => (authorRefs.current[index] = el)}
              className="guideAuthor"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              onMouseEnter={() => checkOverflow(index, "author")}
            >
              {guide?.authorname}
            </p>
          </Tooltip>
                     </div>
                  </div>
                  {role === STUDENT_ROLE ?
                  <div className='guideActionsCtn'>
                        <img src={RightClickArrow} alt="action" /> 
                  </div> :
                  <div className='guideActionsCtn' onClick={(event) => handleClickMoreIcon(event, guide)} >
                     {guide?.isclassroom ?
                        <img src={greyMoreIcon} alt="action" className='moreIcon' /> :
                        <img src={ShareIcon} alt="share"  className='shareIcon'/>
                     } 
                  </div>}
               </div>
            ))
         ) : (
            <div className='noDataFoundStyle'>No data found</div>
         )}
         <MaterialActionsOverlay
            anchorEl={anchorEl}
            open={openOverlay}
            handleClose={handleCloseActions}
            menuItems={menuItems}
            actionsHeight={'90px'}
            position="left"
         />
         <ConfirmationPopup
            open={openConfirmationPopup}
            message={action==="share" ? `Are you sure you want to Share this file with your Class?`:`Are you sure you want to Delete this file from the Classroom?`}
            gifData={action==="share" ? ShareGif: DeleteGif }
            yesButtonFunctionality={onYesButtonClick}
            noButtonFunctionality={onNoButtonClick}
            messageWidth={'195px'}
         />
      </div>
   )
}

export default ExamGuideContainer;
